import React from "react";

const MarkerIcon = () => (
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <path d="M810.08686453 393.41737274C810.08686453 225.95444909 676.17372907 90.125 510.88453366 90.125 345.63824179 90.125 211.68220362 225.9401482 211.68220362 393.41737274a304.89406813 304.89406813 0 0 0 40.34269005 151.67478818H251.72457635l259.13135551 379.15836905 259.27436452-379.15836905h-0.35752093a304.02171634 304.02171634 0 0 0 40.32838998-151.67478819z" />
  </svg>
);
export default MarkerIcon;
